import React, { useState } from 'react';
import moment from 'moment';
import printTicket from '../../pages/RegistroVentas/Ticket';
import { notificarError } from '../Almacenes/AlmacenNotify';

const BotonImprimir = ({ idPedido, className }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getVale = async (idVenta) => {
        try {
            const req = await fetch(`/api/vales/get/${idVenta}`);
            if (!req.ok) {
                throw new Error("Ocurrió un error al obtener datos del pedido.");
            }
            const { respuesta } = await req.json();
            return respuesta[0];
        } catch (e) {
            setError(e.message);
            throw e;
        }
    }

    const getPedidoById = async () => {
        try {
            const req = await fetch(`/api/pedidos/${idPedido}`);
            if (!req.ok) {
                throw new Error("Ocurrió un error al obtener datos del pedido.")
            }
    
            return await req.json();
        } catch (e) {
            notificarError(e.message)
        }
    }

    const getDetallesVale = async (idVenta) => {
        try {
            const req = await fetch(`/api/vales/detalles/${idVenta}`);
            if (!req.ok) {
                throw new Error("Ocurrió un error al obtener datos del pedido.")
            }

            const { respuesta } = await req.json();

            return respuesta;
        } catch (e) {
            notificarError(e.message)
        }
    }

    const handlePrint = async () => {
        if (!idPedido) {
            setError('No se proporcionó ID de venta');
            return;
        }

        try {
            setLoading(true);
            setError(null);

            const pedido = await getPedidoById(idPedido);
            
            // Fetch all required data
            const vale = await getVale(pedido.IdVenta);
            
            if (!vale) {
                throw new Error('No se encontró el vale');
            }

            const totalPagado = vale.totalPagado || 0;
            const totales = {
                total: vale.total || 0
            };
            const montoRestante = totales.total - totalPagado;

            // Prepare detallesVale
            const detallesVale = await getDetallesVale(pedido.IdVenta);

            // Call printTicket with all the data
            await printTicket(detallesVale, vale, 'png', {
                montoPagado: totalPagado,
                total: totales.total,
                restante: montoRestante,
                fechaEntrega: moment(pedido.FechaEntrega).format("DD-MM-YYYY"),
            });
        } catch (err) {
            setError(err.message || 'Error al imprimir el ticket');
            console.error('Print error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <button onClick={handlePrint} className={`btn btn-success btn-verde-mfp-letra-normal ${className}`}>
            {loading ? 'Imprimiendo...' : 'Imprimir Ticket'}
        </button>
    );
};

export default BotonImprimir;
